import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useFormikContext } from 'formik'
import { useRegisterContext } from './Context'
import { Alert, ShowIf } from '@ztechapps/webui.util'

export const ErrorDisplay = () => {
  const { errorMessage } = useRegisterContext()
  const { submitCount, errors } = useFormikContext()

  return (
    <>
      <ShowIf condition={!isEmpty(errorMessage)}>
        <Alert>
          <div>{errorMessage}</div>
        </Alert>
      </ShowIf>
      <ShowIf condition={isEmpty(errorMessage) && submitCount > 0 && !isEmpty(errors)}>
        <Alert>
          <div>Please fix the highlighted fields before continuing.</div>
        </Alert>
      </ShowIf>
    </>
  )
}
